<nav
    class="navbar navbar-expand-lg navbar-custom"
    role="navigation"
    id="navigation"
    tabindex="-1"
    appSetFocus="navigation"
    [ngClass]="!this.commonService.enableHeaderUserManagement ? 'custom-nav' : ''"
>
    <app-skip-to-content
        [idName]="'skip-navigation'"
        [idRef]="'main'"
        [label]="'shell.header.skipNavigation' | translate"
    ></app-skip-to-content>

    <a
        *ngIf="getHeaderImageLink"
        class="navbar-brand"
        [routerLink]="routerHome"
        [attr.aria-label]="'shell.header.headerLogoLink' + logoDefault | translate : { tenantName: homeLinkLabel }"
    >
        <img
            class="headerLogo img-fluid"
            [src]="getHeaderImageLink"
            [attr.alt]="'shell.header.altLogoLink' + logoDefault | translate : { tenantName: homeLinkLabel }"
            editable
            translate
        />
    </a>

    <button
        *ngIf="this.commonService.enableHeaderUserManagement"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Menu"
        (click)="isCollapsed = !isCollapsed"
    >
        <span class="navbar-toggler-icon">
            <i class="fa fa-user custom-toggler-color"></i>
        </span>
    </button>

    <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
        [ngbCollapse]="isCollapsed"
        *ngIf="this.commonService.enableHeaderUserManagement"
    >
        <div class="navbar-nav ml-auto text-center">
            <!--Dropdown Menu -->
            <div
                class="nav-item position-relative d-none d-lg-block d-xl-block"
                ngbDropdown
                placement="bottom-right"
                #menuDrop="ngbDropdown"
            >
                <span class="navbar-toggler-icon desktop-view" *ngIf="!mobileDetected || !tabletDetected">
                    <i class="fa fa-user custom-toggler-color"></i>
                </span>
                <a class="nav-link" ngbDropdownToggle role="button" id="dropdownMenuLink" tabindex="0" (keydown.enter)="menuDrop.open()">
                    <ng-container *ngIf="!isVerifiedUser; else verfiedUserBlock">
                        {{ 'shell.header.signIn' | translate }}
                    </ng-container>
                    <ng-template #verfiedUserBlock>
                        {{ 'shell.header.greeting' | translate }} <span>{{ displayName }}</span>
                    </ng-template>
                </a>
                <div class="dropdown-menu text-md-left text-center" aria-labelledby="dropdownMenuLink" ngbDropdownMenu>
                    <ng-container *ngFor="let menu of menuMapping">
                        <a
                            class="dropdown-item"
                            ngbDropdownItem
                            [routerLink]="[menu.routerLink]"
                            id="{{ menu.id }}"
                            editable
                            editable-container-item
                            *ngIf="menu.value"
                            (click)="allowRedirection(menu.value)"
                        >
                            {{ menu.value | translate }}
                        </a>
                    </ng-container>
                </div>
            </div>
            <!-- Mobile Menu -->
            <div class="nav-item d-block d-lg-none d-xl-none" *ngIf="mobileDetected || tabletDetected">
                <ng-container *ngFor="let menu of menuMapping">
                    <a
                        class="nav-link p-md-2 d-block nav-mobile-border"
                        [routerLink]="[menu.routerLink]"
                        id="{{ menu.id }}"
                        editable
                        editable-container-item
                        *ngIf="menu.value"
                        (click)="allowRedirection(menu.value)"
                    >
                        {{ menu.value | translate }}
                    </a>
                </ng-container>
            </div>
            <!-- Mobile Menu -->
            <div class="navbar-text mr-2" *ngIf="isVerifiedUser && showLoginExpirationTimer && (mobileDetected || tabletDetected)">
                <span id="shell.header.loginExpires" editable editable-container-item>{{ 'shell.header.loginExpires' | translate }}</span>
                {{ loginExpiration$ | async }}
            </div>
            <div class="nav-item nav-mobile-border" *ngIf="isVerifiedUser">
                <button
                    class="nav-link p-md-2 border-0 bg-transparent"
                    (click)="logout()"
                    (keydown.enter)="logout()"
                    id="shell.header.logout"
                    editable
                    editable-container-item
                >
                    {{ 'shell.header.logout' | translate }}
                </button>
            </div>
        </div>
    </div>
</nav>
